// コレクトレカ: 下スクロールでsticky降臨、上スクロールでは消さず置きっぱ
// トップ近くで自然にスタイル変化で通常ヘッダーへ
(function () {
  if (typeof document === 'undefined') return;

  function initCustomStickyHeader() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const SHOW_PX = 400;    // 下スクロールで sticky 出現
    const TOP_PX = 250;     // y < 250 まで戻ったら通常スタイルへ復帰
    let stickyActive = false;

    function showSticky() {
      header.classList.add('shopify-section-header-sticky', 'animate');
      stickyActive = true;
    }

    function resetToTop() {
      // sticky解除（フェードでスタイル変化）
      header.classList.remove('shopify-section-header-sticky', 'animate');
      stickyActive = false;
    }

    function onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (!stickyActive && y > SHOW_PX) {
        showSticky();
      } else if (stickyActive && y < TOP_PX) {
        resetToTop();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomStickyHeader);
  } else {
    initCustomStickyHeader();
  }
})();

// コレクトレカ: PCヘッダーの親メニューはホバーでサブメニュー展開＋クリックでカテゴリへ遷移
// （モバイルはドロワー(header-drawer)を使うため対象外）
(function () {
  if (typeof document === 'undefined') return;
  const DESKTOP = '(min-width: 990px)';
  const isDesktop = () => window.matchMedia(DESKTOP).matches;

  function initHeaderHoverNav() {
    const menus = document.querySelectorAll('.header__inline-menu header-menu');
    menus.forEach((menu) => {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary.header__menu-item');
      if (!details || !summary) return;
      let closeTimer;

      // ホバーでサブメニュー開閉（PCのみ）
      menu.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeTimer = setTimeout(() => details.removeAttribute('open'), 150);
      });

      // 親ラベルのクリックはトグルではなくカテゴリページへ遷移（PCのみ）
      // capture段階で先取りし、Dawn既定のトグルより先に遷移させる
      const url = summary.getAttribute('data-nav-url');
      if (url) {
        summary.addEventListener(
          'click',
          (e) => {
            if (!isDesktop()) return;
            e.preventDefault();
            e.stopPropagation();
            window.location.href = url;
          },
          true
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderHoverNav);
  } else {
    initHeaderHoverNav();
  }
})();

// コレクトレカ: SP(ドロワー)の親カテゴリをアコーディオン開閉（∨タップでその場に子カテゴリ展開）
(function () {
  if (typeof document === 'undefined') return;

  function initDrawerAccordion() {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('[data-ctr-acc]').forEach((row) => {
      const item = row.closest('.ctr-acc');
      if (!item) return;

      const toggle = () => {
        const open = item.classList.toggle('is-open');
        row.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      row.addEventListener('click', toggle);
      row.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerAccordion);
  } else {
    initDrawerAccordion();
  }
})();
